export const state = {
  data: {
    title: {
      'cont-av': 'Container AV',
      'cont-av-na': 'Container AV-NA',
      'cont-dm': 'Container DM',
      'cont-dm-na': 'Container DM-NA',
      'cont-stock': 'Container Stock',
      'cont-submission': 'Container Submission',
      'cont-repair': 'Container Repair',
      'cont-pti': 'Container PTI',
    },
    showmodal: false,
    items: [
      {
        id: '1',
        code: 'ABS',
        document_no: 'P3038008',
        date_in: '2021-10-02',
        kode: 'EI001210700001',
        eir_no: 'TURW21123',
        container: 'DRYU3321123',
        size: '20',
        type: 'GP',
        seal: 'AKE221',
        exvessel: '33922A/VV3',
        repo: 'repo',
        nopol: 'L 3321 AB',
        ct: 'WW',
        take_by: 'Dodi',
        condition: 'AV',
      },
      {
        id: '2',
        code: 'ABS',
        document_no: 'P3038008',
        date_in: '2021-10-02',
        kode: 'EI001210700001',
        eir_no: 'WWTE21123',
        container: 'WTSU3321123',
        seal: 'KLE332',
        exvessel: '993384/I33',
        repo: 'import',
        size: '20',
        type: 'GP',
        nopol: 'L 3321 AB',
        ct: 'WW',
        condition: 'DM',
      },
      {
        id: '3',
        code: 'JBW',
        document_no: 'AKM443123',
        date_in: '2021-10-02',
        kode: 'EI001210700002',
        eir_no: 'J3U321123',
        container: 'KLTW3313341',
        seal: 'KLE332',
        exvessel: '993384/I33',
        repo: 'import',
        size: '20',
        type: 'GP',
        nopol: 'L 3321 AB',
        ct: 'WW',
        condition: 'AV',
      },
      {
        id: '3',
        code: 'JBW',
        document_no: 'UTW445223',
        date_in: '2021-10-02',
        kode: 'EI001210700002',
        eir_no: 'EEKW21123',
        container: 'RTWQ4432214',
        seal: 'KLE332',
        exvessel: '993384/I33',
        repo: 'import',
        size: '20',
        type: 'GP',
        nopol: 'L 3321 AB',
        ct: 'WW',
        condition: 'AV',
      },
    ],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    filter: null,
    filterOn: [],
    sortBy: 'age',
    sortDesc: true,
    fields: {
      'cont-av': [
        {
          key: 'code',
          label: 'Principle',
          sortable: true,
        },
        {
          key: 'document_no',
          label: 'B/L No',
          sortable: true,
        },
        {
          key: 'container',
          label: 'Container',
        },
        {
          key: 'seal',
          label: 'Seal',
        },
        {
          key: 'size',
          label: 'Size',
        },
        {
          key: 'type',
          label: 'Type',
        },
        {
          key: 'exvessel',
          label: 'Exvessel/Voy',
        },
        {
          key: 'repo',
          label: 'Repo',
        },
        {
          key: 'date_in',
          label: 'Date In',
          sortable: false,
        },
      ],
      'cont-av-na': [
        {
          key: 'code',
          label: 'Principle',
          sortable: true,
        },
        {
          key: 'document_no',
          label: 'B/L No',
          sortable: true,
        },
        {
          key: 'container',
          label: 'Container',
        },
        {
          key: 'seal',
          label: 'Seal',
        },
        {
          key: 'size',
          label: 'Size',
        },
        {
          key: 'type',
          label: 'Type',
        },
        {
          key: 'exvessel',
          label: 'Exvessel/Voy',
        },
        {
          key: 'repo',
          label: 'Repo',
        },
        {
          key: 'date_in',
          label: 'Date In',
          sortable: false,
        },
      ],
      'cont-dm': [
        {
          key: 'code',
          label: 'Principle',
          sortable: true,
        },
        {
          key: 'document_no',
          label: 'B/L No',
          sortable: true,
        },
        {
          key: 'container',
          label: 'Container',
        },
        {
          key: 'seal',
          label: 'Seal',
        },
        {
          key: 'size',
          label: 'Size',
        },
        {
          key: 'type',
          label: 'Type',
        },
        {
          key: 'exvessel',
          label: 'Exvessel/Voy',
        },
        {
          key: 'repo',
          label: 'Repo',
        },
        {
          key: 'date_in',
          label: 'Date In',
          sortable: false,
        },
      ],
      'cont-dm-na': [
        {
          key: 'code',
          label: 'Principle',
          sortable: true,
        },
        {
          key: 'document_no',
          label: 'B/L No',
          sortable: true,
        },
        {
          key: 'container',
          label: 'Container',
        },
        {
          key: 'seal',
          label: 'Seal',
        },
        {
          key: 'size',
          label: 'Size',
        },
        {
          key: 'type',
          label: 'Type',
        },
        {
          key: 'exvessel',
          label: 'Exvessel/Voy',
        },
        {
          key: 'repo',
          label: 'Repo',
        },
        {
          key: 'date_in',
          label: 'Date In',
          sortable: false,
        },
      ],
      'cont-stock': [
        {
          key: 'kode',
          label: 'Kode',
          sortable: true,
        },
        {
          key: 'eir_no',
          label: 'EIR',
          sortable: true,
        },
        {
          key: 'code',
          label: 'Principle',
          sortable: true,
        },
        {
          key: 'document_no',
          label: 'B/L No',
          sortable: true,
        },
        {
          key: 'container',
          label: 'Container',
        },
        {
          key: 'size',
          label: 'Size',
        },
        {
          key: 'type',
          label: 'Type',
        },
        {
          key: 'date_in',
          label: 'Date In',
          sortable: false,
        },
        {
          key: 'take_by',
          label: 'Taken By',
        },
      ],
      'cont-submission': [
        {
          key: 'code',
          label: 'Principle',
          sortable: true,
        },
        {
          key: 'document_no',
          label: 'B/L No',
          sortable: true,
        },
        {
          key: 'container',
          label: 'Container',
        },
        {
          key: 'seal',
          label: 'Seal',
        },
        {
          key: 'size',
          label: 'Size',
        },
        {
          key: 'type',
          label: 'Type',
        },
        {
          key: 'exvessel',
          label: 'Exvessel/Voy',
        },
        {
          key: 'repo',
          label: 'Repo',
        },
        {
          key: 'date_in',
          label: 'Date In',
          sortable: false,
        },
      ],
      'cont-repair': [
        {
          key: 'code',
          label: 'Principle',
          sortable: true,
        },
        {
          key: 'document_no',
          label: 'B/L No',
          sortable: true,
        },
        {
          key: 'container',
          label: 'Container',
        },
        {
          key: 'seal',
          label: 'Seal',
        },
        {
          key: 'size',
          label: 'Size',
        },
        {
          key: 'type',
          label: 'Type',
        },
        {
          key: 'exvessel',
          label: 'Exvessel/Voy',
        },
        {
          key: 'repo',
          label: 'Repo',
        },
        {
          key: 'date_in',
          label: 'Date In',
          sortable: false,
        },
      ],
      'cont-pti': [
        {
          key: 'code',
          label: 'Principle',
          sortable: true,
        },
        {
          key: 'document_no',
          label: 'B/L No',
          sortable: true,
        },
        {
          key: 'container',
          label: 'Container',
        },
        {
          key: 'seal',
          label: 'Seal',
        },
        {
          key: 'size',
          label: 'Size',
        },
        {
          key: 'type',
          label: 'Type',
        },
        {
          key: 'exvessel',
          label: 'Exvessel/Voy',
        },
        {
          key: 'repo',
          label: 'Repo',
        },
        {
          key: 'date_in',
          label: 'Date In',
          sortable: false,
        },
      ],
    },
    form: {
      code: '',
      name: '',
      address: '',
      city: '',
      province: '',
      country: '',
      postal_code: '',
      email: '',
      phone: '',
      fax: '',
      free_storage: '',
      add_storage: '',
      min_storage: '',
      max_storage: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeEir(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  getListPrinciple({ commit }, message) {
    commit('changeEir', message);
  },

  createBooking({ commit, state }) {
    commit('changeEir', {
      loading: true,
    });

    console.log(state.data.form);
  },
};
